import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { applyRequiredCapitalizations } from '../../../util/TextUtils';
import BookingModal from '../BookingModal/BookingModal';
import { setExperiencesList, setExperienceSelected, setExperienceBookingModal } from '../../../actions/experiences';
import CalendarImage from '../../../resources/Calendar.png';
import analyticsContext from '../../analytics/Analytics';
import { theme } from '../../../../../themes';

class BookingLauncher extends Component {
  constructor(props) {
    super(props);
    this.reportingEventSent = false;
  }

  showBookingModal = (bookingModal) => {
    this.props.onShowBookingModal();
    this.props.setExperienceBookingModal(bookingModal);
  };
  componentDidUpdate(prevProps) {
    const prevCallMeNowSate = prevProps.callMeNowResponse && prevProps.callMeNowResponse.state;
    const currentState = this.props.callMeNowResponse && this.props.callMeNowResponse.state;
    if (currentState !== prevCallMeNowSate && currentState === 'success') {
      const mode = this.isCallMeNowAvailable() ? 'callMeNow' : 'callMeLater';

      analyticsContext
        .withAdvancedProps({
          section: 'bookingLauncher',
          mode,
          experience: this.props.experienceSelected && this.props.experienceSelected.megaUseCase,
        })
        .screenEvent();
    }
  }
  hideBookingModal = () => {
    this.props.setExperienceBookingModal(false);
  };

  renderCallMeNowOrLater = () => {
    return (
      <div className="callMeNowLauncher">
        <div
          className="bookingLauncherTitle articleTitleFonts"
          style={{ color: theme.colors.featureSection2FontColor }}
        >
          {applyRequiredCapitalizations('Get Started')}
        </div>
        <div className="bookingLauncherText bodyTextFonts" style={{ color: theme.colors.featureSection2FontColor }}>
          You can start this session right away, or book it for when you have time. We'll call you.
        </div>
        <a
          className="btn inGreen phoneTablet smallPhoneFit"
          style={{
            backgroundColor: theme.colors.experiencesPrimaryButtonBackground || theme.colors.primaryAccent,
            borderColor: theme.colors.experiencesPrimaryButtonTitle || theme.colors.primaryAccent,
            color: theme.colors.experiencesPrimaryButtonTitle || theme.colors.primaryAccentFontColor,
          }}
          onClick={this.showBookingModal.bind(this, 'callMeNow')}
        >
          {applyRequiredCapitalizations('Call Me Now')}
        </a>
        {/* <div className="orBreak">or</div> */}
        <a
          className="btn outGreen phoneTablet smallPhoneFit"
          style={{
            borderColor: theme.colors.experiencesBookingLauncherBookLaterButtonTitle,
            color: theme.colors.experiencesBookingLauncherBookLaterButtonTitle,
          }}
          onClick={this.showBookingModal.bind(this, 'callMeLater')}
        >
          {applyRequiredCapitalizations('Book for Later')}
        </a>
      </div>
    );
  };

  renderCallMeLater = () => {
    return (
      <div className="callMeLaterLauncher">
        <div
          className="bookingLauncherTitle articleTitleFonts"
          style={{ color: theme.colors.featureSection2FontColor }}
        >
          {applyRequiredCapitalizations('Get Started')}
        </div>
        <div className="bookingLauncherText bodyTextFonts" style={{ color: theme.colors.featureSection2FontColor }}>
          You can book this session for a time that is convenient to you. We'll call you.
        </div>
        <a
          className="btn inGreen phoneTablet"
          style={{
            backgroundColor: theme.colors.experiencesPrimaryButtonBackground || theme.colors.primaryAccent,
            borderColor: theme.colors.experiencesPrimaryButtonTitle || theme.colors.primaryAccent,
            color: theme.colors.experiencesPrimaryButtonTitle || theme.colors.primaryAccentFontColor,
          }}
          onClick={this.showBookingModal.bind(this, 'callMeLater')}
        >
          {applyRequiredCapitalizations('Book Now')}
        </a>
      </div>
    );
  };

  isCallMeNowAvailable = () => {
    return (
      this.props.callMeNowResponse &&
      this.props.callMeNowResponse.state === 'success' &&
      !!this.props.callMeNowResponse.vhtSlots.length &&
      this.props.callMeNowResponse.waitInMinutes <= this.props.maxCustomerWaitTime
    );
  };

  render = () => (
    <div
      className="bookingLauncherContainer"
      style={{
        backgroundColor: theme.colors.featureSection2,
        boxShadow: theme.colors.experiencesBookingLauncherBoxShadow,
      }}
    >
      {this.isCallMeNowAvailable() ? this.renderCallMeNowOrLater() : this.renderCallMeLater()}
      {!!this.props.experienceBookingModal && <BookingModal parentCloseHandler={this.hideBookingModal} />}
    </div>
  );
}

BookingLauncher.propTypes = {
  onShowBookingModal: PropTypes.func,
};

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesList:
    state.experiences.experiencesList && state.experiences.experiencesList.version === 2
      ? state.experiences.experiencesList.data
      : null,
  experienceSelected: state.experiences.experienceSelected,
  experienceBookingModal: state.experiences.experienceBookingModal,
  callMeNowResponse: state.callMeNow.callMeNowResponse,
  maxCustomerWaitTime: state.callMeNow.maxCustomerWaitTime,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setExperiencesList,
      setExperienceSelected,
      setExperienceBookingModal,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookingLauncher));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/BookingLauncher/BookingLauncher.js